import { render, staticRenderFns } from "./tnc-kr.vue?vue&type=template&id=f823bf88&scoped=true"
import script from "./tnc-kr.vue?vue&type=script&lang=js"
export * from "./tnc-kr.vue?vue&type=script&lang=js"
import style0 from "./tnc-kr.vue?vue&type=style&index=0&id=f823bf88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f823bf88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f823bf88')) {
      api.createRecord('f823bf88', component.options)
    } else {
      api.reload('f823bf88', component.options)
    }
    module.hot.accept("./tnc-kr.vue?vue&type=template&id=f823bf88&scoped=true", function () {
      api.rerender('f823bf88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-kr.vue"
export default component.exports